import { Box, IconButton, Table, TableBody, TableCell, TableRow, styled } from '@mui/material';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import { ActionButton, CancelButton, SubmitButton } from 'components/ui/buttons';
import Tooltip from 'components/popups/Tooltip';

export default function RegistrationQuestions({
    mode,
    firstName,
    lastName,
    email,
    questions,
    onNewQuestion,
    onQuestionSelect,
    onSort,
    enableSort,
    onSortStart,
    onSortCancel,
    onSortSubmit,
}) {
    const requiredQuestions = [];

    if (mode === 2) {
        if (firstName) requiredQuestions.push('First Name');
        if (lastName) requiredQuestions.push('Last Name');
        if (email) requiredQuestions.push('Email Address');
    }

    // Each custom question has an order property.
    // If required questions are shown above, offset the displayed order accordingly.
    const orderOffset = requiredQuestions.length;

    return (
        <>
            <Table>
                <TableBody>
                    {requiredQuestions.map((question, index) => (
                        <TableRow key={index} style={{ height: 68 }}>
                            <TableCell>#{index + 1}</TableCell>
                            <TableCell />
                            <TableCell style={{ fontStyle: 'italic' }}>
                                {question} (required)
                            </TableCell>
                            <TableCell />
                        </TableRow>
                    ))}

                    {questions.map((question, index) => (
                        <TableRow
                            key={question.q_id}
                            style={{ backgroundColor: question.highlight ? '#eee' : 'white' }}
                        >
                            <TableCell width={5}>#{question.order + orderOffset}</TableCell>
                            <TableCell width={5}>
                                <Box display="flex" justifyContent="center" alignItems="center">
                                    {question.visible ? <VisibleIcon /> : <HiddenIcon />}
                                </Box>
                            </TableCell>
                            <TableCell>{question.q_desc}</TableCell>
                            {enableSort === true ? (
                                <TableCell align="right" width={80}>
                                    <ArrowButton
                                        disabled={index === 0}
                                        onClick={() => onSort(question.q_id, 'up')}
                                    >
                                        <ArrowDropUpIcon />
                                    </ArrowButton>
                                    <ArrowButton
                                        disabled={index === questions.length - 1}
                                        onClick={() => onSort(question.q_id, 'down')}
                                    >
                                        <ArrowDropDownIcon />
                                    </ArrowButton>
                                </TableCell>
                            ) : (
                                <TableCell align="right" width={60}>
                                    <ActionButton onClick={() => onQuestionSelect(question.q_id)}>
                                        Edit
                                    </ActionButton>
                                </TableCell>
                            )}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            {enableSort === true ? (
                <Box display="flex" justifyContent="flex-end" mt={2}>
                    <CancelButton onClick={onSortCancel}>Cancel</CancelButton>
                    <SubmitButton onClick={onSortSubmit}>Save</SubmitButton>
                </Box>
            ) : (
                <Box display="flex" justifyContent="flex-end" mt={2}>
                    <ActionButton onClick={onNewQuestion}>New Question</ActionButton>
                    <Tooltip message="Your customers will see your questions in the order listed above. You can change the Display Order here.">
                        <span style={{ marginLeft: 8 }}>
                            <ActionButton startIcon={<SwapVertIcon />} onClick={onSortStart}>
                                Set Display Order
                            </ActionButton>
                        </span>
                    </Tooltip>
                </Box>
            )}
        </>
    );
}

const ArrowButton = styled(IconButton)(({ theme }) => ({
    backgroundColor: theme.palette.grey[200],
    marginLeft: theme.spacing(1),
}));
ArrowButton.defaultProps = { size: 'small', disableRipple: true };

const VisibleIcon = styled(VisibilityIcon)(({ theme }) => ({
    color: theme.palette.success.main,
}));

const HiddenIcon = styled(VisibilityOffIcon)(({ theme }) => ({
    color: theme.palette.grey[500],
}));
